<template>
  <div class="HeaderClientRemote row align-center">
    <div class="row grid-10 grid-7-s menu align-center">
      <div class="grid-9 row align-center">
        <a href="/atendimento" class="row">
          <img
            :src="theme.logo"
            class="logo"
            :width="user.white_label == 'ns' ? '200' : '100'"
          />
        </a>
        <Button
          v-if="showButtons"
          class="hide-s"
          layout="remote-newJob"
          onclick="Kommunicate.launchConversation()"
        >
          <i class="fa fa-comment"></i> SOLICITAR ATENDIMENTO
        </Button>
      </div>
      <div class="grid-3 row justify-end align-center">
        <Button
          v-if="showButtons"
          class="hide-s"
          id="help"
          layout="remote-how"
          @click="guideModal.show = true"
        >
          <i class="fa fa-question-circle"></i> COMO FUNCIONA?
        </Button>
        <button
          v-if="showButtons"
          class="how hide-m hide-g"
          id="help"
          @click="guideModal.show = true"
          title="COMO FUNCIONA?"
        >
          <i class="fa fa-question-circle"></i>
        </button>
        <Notify />
      </div>
    </div>
    <div class="row grid-2 grid-4-s userTab">
      <UserTab :exit="user.cliente ? theme.exit : user.url_frotend" />
    </div>
    <div :class="guideModal.guideClass">
      <Modal :modal="guideModal" />
    </div>
  </div>
</template>

<script>
import UserTab from "@/components/UserTabRemote.vue";
import Button from "@/components/Button.vue";
import Notify from "@/components/NotifyRemote.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import Modal from "@/components/Modal.vue";

export default {
  name: "HeaderClientRemote",
  props: { theme: Object },
  components: {
    UserTab,
    Notify,
    Button,
    Modal,
  },
  data() {
    return {
      showButtons: location.pathname == "/avaliacao" ? false : true,
      showMenu: false,
      menu: {
        dashboard: true,
        newJob: false,
        attendance: false,
        remote: false,
      },
      guideModal: {
        show: false,
        layout: "Guide",
        hideClose: true,
        guideClass: "guide-modal-1",
        theme: this.theme,
      },
    };
  },
  methods: {
    ...mapActions("user", ["SET_LOGOUT"]),
    ...mapMutations("jobs", ["SET_JOBS"]),
    changeMenu(active) {
      this.SET_JOBS([]);
      this.menu = {
        dashboard: false,
        newJob: false,
        attendance: false,
        remote: false,
      };
      this.menu[active] = true;
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.HeaderClientRemote {
  padding: 20px;
  height: 80px;

  @media (max-width: $small) {
    padding: 5px;
  }

  .menu {
    height: 75px;
    padding: 0px 20px;
    border-radius: 10px;
    .logo {
      margin-right: 50px;
      width: 160px;
    }
  }
  .userTab {
    margin-left: 20px;
    border-radius: 10px;
    @media (max-width: $small) {
      margin-left: 6px;
    }
  }
  .how {
    width: 37px;
    height: 37px;
    text-align: center;
    line-height: 42px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    color: #fff;
    i {
      font-size: 22px;
    }
  }

  #help {
    @media (max-width: $small) {
      margin-right: -15px;
    }
  }
}
</style>
